(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-glow-logo-cloud"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-logo-carousel')) {
    class BrandLogoCarousel extends HTMLElement {
      static pixelsPerSecond = 48.55;

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.viewport = this.querySelector('[data-logo-carousel-viewport]');
        this.track = this.querySelector('[data-logo-carousel-track]');
        this.group = this.querySelector('[data-logo-carousel-group]');
        this.items = Array.from(this.querySelectorAll('[data-logo-carousel-item]'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isIntersecting = true;

        if (!this.viewport || !this.track || !this.group || !this.items.length) return;

        this.buildLoop();
        this.bindEvents();
        this.configureAnimation();
        this.updatePlayback();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.animation?.cancel();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);

        if (this.reducedMotion?.removeEventListener) {
          this.reducedMotion.removeEventListener('change', this.handleReducedMotionChange);
        } else {
          this.reducedMotion?.removeListener(this.handleReducedMotionChange);
        }

        if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
      }

      buildLoop() {
        const clone = this.group.cloneNode(true);
        clone.removeAttribute('data-logo-carousel-group');
        clone.setAttribute('data-logo-carousel-clone-group', '');
        clone.setAttribute('role', 'presentation');
        clone.setAttribute('aria-hidden', 'true');

        clone.querySelectorAll('[data-logo-carousel-item]').forEach((item) => {
          item.removeAttribute('data-logo-carousel-item');
          item.removeAttribute('id');
          item.setAttribute('data-logo-carousel-clone', '');
          item.setAttribute('role', 'presentation');
        });

        clone.querySelectorAll('img').forEach((image) => image.setAttribute('alt', ''));
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('*').forEach((element) => {
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
          });
        });

        this.track.append(clone);
        this.dataset.loopReady = 'true';
      }

      bindEvents() {
        this.handleVisibilityChange = () => this.updatePlayback();
        this.handleReducedMotionChange = () => {
          this.configureAnimation();
          this.updatePlayback();
        };
        this.handleResize = () => {
          if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = window.requestAnimationFrame(() => {
            this.resizeFrame = null;
            this.configureAnimation();
          });
        };

        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.handleReducedMotionChange);
        } else {
          this.reducedMotion.addListener(this.handleReducedMotionChange);
        }

        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(
            ([entry]) => {
              this.isIntersecting = entry.isIntersecting;
              this.updatePlayback();
            },
            { threshold: 0.01 }
          );
          this.intersectionObserver.observe(this.viewport);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.group);
        }
      }

      configureAnimation() {
        const loopDistance = this.group.getBoundingClientRect().width;
        const motionPreferenceChanged = this.motionReduced !== this.reducedMotion.matches;
        if (!loopDistance || (!motionPreferenceChanged && Math.abs(loopDistance - this.loopDistance) < 0.1)) return;
        this.motionReduced = this.reducedMotion.matches;

        if (this.reducedMotion.matches) {
          this.animation?.cancel();
          this.animation = null;
          this.loopDistance = loopDistance;
          this.loopDuration = 0;
          this.track.style.transform = 'translate3d(0, 0, 0)';
          return;
        }

        const duration = (loopDistance / BrandLogoCarousel.pixelsPerSecond) * 1000;
        const currentOffset = this.animation && this.loopDuration
          ? ((Number(this.animation.currentTime) || 0) % this.loopDuration) / this.loopDuration * this.loopDistance
          : 0;
        const keyframes = [
          { transform: 'translate3d(0, 0, 0)' },
          { transform: `translate3d(-${loopDistance}px, 0, 0)` }
        ];
        const timing = {
          duration,
          iterations: Infinity,
          easing: 'linear',
          fill: 'both'
        };

        if (this.animation) {
          this.animation.effect.setKeyframes(keyframes);
          this.animation.effect.updateTiming(timing);
        } else {
          this.animation = this.track.animate(keyframes, timing);
          this.animation.pause();
        }

        this.loopDistance = loopDistance;
        this.loopDuration = duration;
        this.animation.currentTime = (currentOffset % loopDistance) / BrandLogoCarousel.pixelsPerSecond * 1000;
        this.track.style.setProperty('--logo-loop-duration', `${(duration / 1000).toFixed(4)}s`);
        this.dataset.loopSpeed = String(BrandLogoCarousel.pixelsPerSecond);
        this.dataset.loopDistance = loopDistance.toFixed(3);
        this.updatePlayback();
      }

      updatePlayback() {
        const shouldRun = Boolean(
          this.animation &&
          !this.reducedMotion.matches &&
          this.isIntersecting &&
          !document.hidden
        );

        if (shouldRun) {
          this.animation.play();
        } else {
          this.animation?.pause();
        }

        this.dataset.animating = String(shouldRun);
      }
    }

    customElements.define('brand-logo-carousel', BrandLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
